import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { css } from '@emotion/react';

import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalTitle } from 'components/global/styled/Modal.styled';

import PATHS from 'utils/paths';

import * as S from './UpgradePlanModal.styles';

const UpgradePlanModal = NiceModal.create(({ newPlan }) => {
	const { t } = useTranslation();
	const modal = useModal();
	const navigate = useNavigate();
	const handleCloseModal = () => {
		modal.remove();
	};
	const { planName } = useSelector((state) => state.user);

	return (
		<Modal maxWidth="small" fullwidth closeButton className="modal-confirmation">
			<ModalTitle>
				<Typography variant="p1" fontWeight="500">
					{newPlan ? (
						<>
							{t('upgrageTo')} {t(newPlan)}
						</>
					) : (
						t('upgradePlan')
					)}
				</Typography>
			</ModalTitle>
			<S.Content>
				<S.ImageContainer>
					<Image
						url="https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/upgradeAccount.svg"
						width="15rem"
						height="15rem"
					/>
				</S.ImageContainer>
				<S.TextContainer>
					<Typography
						variant="p1"
						fontWeight="700"
						noWrap
						css={css`
							line-height: var(--paragraph1-line-height);
						`}>
						<Trans
							i18nKey="upgradePlanModalHeader"
							values={{
								currentPackageName: t(planName),
								selectedPackageName: t(newPlan)
							}}
						/>
					</Typography>

					<Typography
						variant="p3"
						color="var(--content-2)"
						noWrap
						css={css`
							line-height: var(--paragraph3-line-height);
						`}>
						{t('upgradePlanModalSubtitle')}
					</Typography>
				</S.TextContainer>
			</S.Content>
			<ModalActions>
				<Button
					onClick={() => {
						handleCloseModal();
					}}
					label={t('cancel')}
					variant="borderless"
				/>

				<Button
					onClick={() => {
						navigate(PATHS.OTO_MODULES);
						handleCloseModal();
					}}
					variant="blue"
					label={t('checkOtoPlans')}
				/>
			</ModalActions>
		</Modal>
	);
});

export default UpgradePlanModal;
